module.exports = __webpack_public_path__ + "assets/img/67_519_1.6a2bcb93.jpg";